import React from "react";

const Footer = () => {
  return (
    <footer className="py-12 px-4 bg-muted/30 border-t">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center">
          <h3 className="text-xl font-bold text-primary mb-4">Casal Resolve</h3>
          <p className="text-muted-foreground mb-4">
            Fortalecendo relacionamentos através do diálogo e respeito
          </p>
          <p className="text-sm text-muted-foreground">
            © 2024 Casal Resolve. Todos os direitos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;